import React, { useEffect, useState } from 'react';
import bgImage from '../../assets/images/12188655_4914784.jpg';
import { FaCog, FaShoppingCart } from 'react-icons/fa';

const StatsSection = () => {
  const [plantCapacity, setPlantCapacity] = useState(0);
  const [monthlyProduction, setMonthlyProduction] = useState(0);

  // Animate counting numbers
  useEffect(() => {
    let cap = 0;
    let prod = 0;

    const capInterval = setInterval(() => {
      cap += 5;
      if (cap >= 437) {
        cap = 437;
        clearInterval(capInterval);
      }
      setPlantCapacity(cap);
    }, 10);

    const prodInterval = setInterval(() => {
      prod += 2000;
      if (prod >= 100000) {
        prod = 100000;
        clearInterval(prodInterval);
      }
      setMonthlyProduction(prod);
    }, 10);

    return () => {
      clearInterval(capInterval);
      clearInterval(prodInterval);
    };
  }, []);

  return (
    <div
      className="relative py-20 bg-cover bg-center text-white"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/30 z-0" />

      {/* Content */}
      <div className="relative z-10 text-center mb-12 px-4">
        <p className="text-[#f1eaea] text-sm mb-2 font-semibold tracking-wide uppercase">
          Our Production Stats
        </p>
        <h2 className="text-4xl font-bold mb-2 text-white">
          The Numbers Say It All
        </h2>
        <p className="text-sm md:text-base max-w-2xl mx-auto text-gray-200">
          Salient facts of CED Coatings that demonstrate our strength in capacity and monthly output.
        </p>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 px-6">
        {/* Plant Capacity */}
        <div className="bg-[#f1f0ea] text-center text-black p-10 rounded-md shadow-md hover:shadow-xl transition-shadow">
          <FaCog size={50} className="mx-auto text-[#7d3f3f] mb-4" />
          <h3 className="text-5xl font-extrabold">{plantCapacity}</h3>
          <p className="mt-2 font-semibold text-[#333] text-sm">
            Plant Capacity (m²/hr)
          </p>
        </div>

        {/* Monthly Production */}
        <div className="bg-[#f1f0ea] text-center text-black p-10 rounded-md shadow-md hover:shadow-xl transition-shadow">
          <FaShoppingCart size={50} className="mx-auto text-[#7d3f3f] mb-4" />
          <h3 className="text-5xl font-extrabold">{monthlyProduction}</h3>
          <p className="mt-2 font-semibold text-[#333] text-sm">
            Monthly Production (m²)
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
